import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Download, ChevronUp, ChevronDown, Trash2 } from 'lucide-react';

export function AdminInfluencersTab({
  influencerAnalytics, expandedUser, setExpandedUser, handleDeleteUser, exportCSV
}) {
  const exportInfluencers = () => exportCSV(influencerAnalytics, 'influenciadores', [
    { label: 'Nome', key: 'name' }, { label: 'Nome Completo', key: 'full_name' },
    { label: 'Email', key: 'email' }, { label: 'CPF', key: 'cpf' },
    { label: 'WhatsApp', key: 'whatsapp' }, { label: 'Cidade', key: 'city' },
    { label: 'Bairro', key: 'neighborhood' }, { label: 'Estado', key: 'state' },
    { label: 'Endereco', key: 'address' }, { label: 'Chave PIX', key: 'pix' },
    { label: 'Total Chaves', key: 'total_keys' }, { label: 'Chaves Usadas', key: 'used_keys' },
    { label: 'Lojistas Ativos', key: 'active_merchants' }, { label: 'Cancelados', key: 'cancelled_merchants' },
    { label: 'Cupons', key: 'total_coupons' },
    { label: 'Comissao Total', get: r => r.total_commission?.toFixed(2) },
    { label: 'Comissao Pendente', get: r => r.pending_commission?.toFixed(2) },
    { label: 'Virtual', get: r => r.is_virtual ? 'Sim' : 'Nao' },
    { label: 'Cadastro', key: 'created_at' }
  ]);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-sm text-slate-500">{influencerAnalytics.length} influenciadores</p>
        <Button size="sm" variant="outline" className="border-slate-300 text-xs" onClick={exportInfluencers} data-testid="export-influencers-btn">
          <Download className="h-3.5 w-3.5 mr-1" /> CSV
        </Button>
      </div>

      {influencerAnalytics.length === 0 && (
        <p className="text-sm text-slate-400 text-center py-8">Nenhum influenciador cadastrado ainda</p>
      )}

      {influencerAnalytics.length > 0 && (
        <Card className="bg-white border border-slate-200">
          <CardHeader><CardTitle className="text-lg text-slate-900">Comparativo entre Bolhas</CardTitle></CardHeader>
          <CardContent>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-slate-200">
                    <th className="text-left py-2 text-slate-500 font-medium">Influenciador</th>
                    <th className="text-center py-2 text-slate-500 font-medium">Chaves</th>
                    <th className="text-center py-2 text-slate-500 font-medium">Lojistas</th>
                    <th className="text-center py-2 text-slate-500 font-medium">Ativos</th>
                    <th className="text-center py-2 text-slate-500 font-medium">Cancelados</th>
                    <th className="text-center py-2 text-slate-500 font-medium">Cupons</th>
                    <th className="text-right py-2 text-slate-500 font-medium">Comissao Total</th>
                    <th className="text-right py-2 text-slate-500 font-medium">Pendente</th>
                  </tr>
                </thead>
                <tbody>
                  {influencerAnalytics.map(inf => (
                    <tr key={inf.user_id} className="border-b border-slate-100 hover:bg-slate-50">
                      <td className="py-2 font-medium text-slate-900">
                        {inf.name}
                        {inf.is_virtual && <Badge className="ml-1 bg-amber-100 text-amber-700 border-amber-200 text-xs">Virtual</Badge>}
                      </td>
                      <td className="py-2 text-center">{inf.used_keys}/{inf.total_keys}</td>
                      <td className="py-2 text-center font-semibold">{inf.total_merchants}</td>
                      <td className="py-2 text-center text-green-600 font-semibold">{inf.active_merchants}</td>
                      <td className="py-2 text-center text-red-600">{inf.cancelled_merchants}</td>
                      <td className="py-2 text-center">{inf.total_coupons}</td>
                      <td className="py-2 text-right font-bold text-amber-700">R$ {inf.total_commission.toFixed(2)}</td>
                      <td className="py-2 text-right text-amber-500">R$ {inf.pending_commission.toFixed(2)}</td>
                    </tr>
                  ))}
                  <tr className="bg-slate-50 font-bold">
                    <td className="py-2 text-slate-900">TOTAL</td>
                    <td className="py-2 text-center">{influencerAnalytics.reduce((s,i) => s + i.used_keys, 0)}/{influencerAnalytics.reduce((s,i) => s + i.total_keys, 0)}</td>
                    <td className="py-2 text-center">{influencerAnalytics.reduce((s,i) => s + i.total_merchants, 0)}</td>
                    <td className="py-2 text-center text-green-600">{influencerAnalytics.reduce((s,i) => s + i.active_merchants, 0)}</td>
                    <td className="py-2 text-center text-red-600">{influencerAnalytics.reduce((s,i) => s + i.cancelled_merchants, 0)}</td>
                    <td className="py-2 text-center">{influencerAnalytics.reduce((s,i) => s + i.total_coupons, 0)}</td>
                    <td className="py-2 text-right text-amber-700">R$ {influencerAnalytics.reduce((s,i) => s + i.total_commission, 0).toFixed(2)}</td>
                    <td className="py-2 text-right text-amber-500">R$ {influencerAnalytics.reduce((s,i) => s + i.pending_commission, 0).toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      )}

      {influencerAnalytics.map(inf => (
        <Card key={inf.user_id} className="bg-white border border-slate-200" data-testid={`inf-bubble-${inf.user_id}`}>
          <CardContent className="py-4">
            <div className="flex items-center justify-between mb-3 cursor-pointer"
              onClick={() => setExpandedUser(expandedUser === inf.user_id ? null : inf.user_id)}>
              <div className="flex items-center gap-3">
                {inf.picture ? (
                  <img src={inf.picture} alt="" className="w-10 h-10 rounded-full" />
                ) : (
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${inf.is_virtual ? 'bg-amber-100' : 'bg-indigo-100'}`}>
                    <span className={`font-bold ${inf.is_virtual ? 'text-amber-600' : 'text-indigo-600'}`}>{(inf.name || 'I')[0]}</span>
                  </div>
                )}
                <div>
                  <div className="flex items-center gap-2">
                    <p className="font-semibold text-slate-900">{inf.name}</p>
                    {inf.is_virtual && <Badge className="bg-amber-100 text-amber-700 border-amber-200 text-xs">Virtual</Badge>}
                  </div>
                  <p className="text-xs text-slate-500">{inf.email || ''} {inf.city && `| ${inf.city}`}</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Badge className="bg-amber-50 text-amber-700 border-amber-200 text-xs font-bold">
                  R$ {inf.total_commission.toFixed(2)} total
                </Badge>
                {!inf.is_virtual && (
                  <Button size="sm" variant="ghost" className="text-red-400 hover:text-red-600 hover:bg-red-50 h-7 w-7 p-0"
                    onClick={(e) => { e.stopPropagation(); handleDeleteUser(inf.user_id); }}
                    data-testid={`delete-inf-${inf.user_id}`}>
                    <Trash2 className="h-3.5 w-3.5" />
                  </Button>
                )}
                {expandedUser === inf.user_id ? <ChevronUp className="h-4 w-4 text-slate-400" /> : <ChevronDown className="h-4 w-4 text-slate-400" />}
              </div>
            </div>

            <div className="grid grid-cols-3 md:grid-cols-6 gap-3 text-center">
              <div className="bg-slate-50 rounded-lg p-2"><p className="text-lg font-bold text-slate-900">{inf.total_keys}</p><p className="text-xs text-slate-500">Chaves</p></div>
              <div className="bg-blue-50 rounded-lg p-2"><p className="text-lg font-bold text-blue-700">{inf.used_keys}</p><p className="text-xs text-blue-500">Usadas</p></div>
              <div className="bg-green-50 rounded-lg p-2"><p className="text-lg font-bold text-green-700">{inf.active_merchants}</p><p className="text-xs text-green-500">Ativos</p></div>
              <div className="bg-red-50 rounded-lg p-2"><p className="text-lg font-bold text-red-700">{inf.cancelled_merchants}</p><p className="text-xs text-red-500">Cancelados</p></div>
              <div className="bg-slate-50 rounded-lg p-2"><p className="text-lg font-bold text-slate-700">{inf.total_coupons}</p><p className="text-xs text-slate-500">Cupons</p></div>
              <div className="bg-amber-50 rounded-lg p-2"><p className="text-lg font-bold text-amber-700">R$ {inf.pending_commission.toFixed(2)}</p><p className="text-xs text-amber-500">Pendente</p></div>
            </div>

            {expandedUser === inf.user_id && (
              <div className="mt-4 space-y-4">
                <div className="border-t border-slate-100 pt-4">
                  <h4 className="text-sm font-bold text-slate-700 mb-2">Dados Cadastrais</h4>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                    <div><p className="text-slate-400 text-xs">Nome Completo</p><p className="text-slate-700">{inf.full_name || inf.name || '-'}</p></div>
                    <div><p className="text-slate-400 text-xs">CPF</p><p className="text-slate-700">{inf.cpf || '-'}</p></div>
                    <div><p className="text-slate-400 text-xs">Email</p><p className="text-slate-700">{inf.email || '-'}</p></div>
                    <div><p className="text-slate-400 text-xs">WhatsApp</p><p className="text-slate-700">{inf.whatsapp || '-'}</p></div>
                    <div><p className="text-slate-400 text-xs">Cidade</p><p className="text-slate-700">{inf.city || '-'}</p></div>
                    <div><p className="text-slate-400 text-xs">Bairro</p><p className="text-slate-700">{inf.neighborhood || '-'}</p></div>
                    <div><p className="text-slate-400 text-xs">Estado</p><p className="text-slate-700">{inf.state || '-'}</p></div>
                    <div><p className="text-slate-400 text-xs">Endereco</p><p className="text-slate-700">{inf.address || '-'}</p></div>
                    <div><p className="text-slate-400 text-xs">Chave PIX</p><p className="text-slate-700">{inf.pix || '-'}</p></div>
                    <div><p className="text-slate-400 text-xs">Cadastro</p><p className="text-slate-700">{inf.created_at ? new Date(inf.created_at).toLocaleDateString('pt-BR') : '-'}</p></div>
                  </div>
                </div>

                <div className="border-t border-slate-100 pt-4">
                  <h4 className="text-sm font-bold text-slate-700 mb-2">Lojistas da Bolha ({inf.merchants?.length || 0})</h4>
                  {inf.merchants?.length > 0 ? (
                    <div className="overflow-x-auto">
                      <table className="w-full text-xs">
                        <thead><tr className="border-b border-slate-200">
                          <th className="text-left py-1.5 text-slate-500">Lojista</th>
                          <th className="text-left py-1.5 text-slate-500">Chave</th>
                          <th className="text-center py-1.5 text-slate-500">Plano</th>
                          <th className="text-center py-1.5 text-slate-500">Adesao</th>
                          <th className="text-center py-1.5 text-slate-500">Prox. Cobranca</th>
                          <th className="text-center py-1.5 text-slate-500">Status</th>
                          <th className="text-right py-1.5 text-slate-500">Valor/mes</th>
                        </tr></thead>
                        <tbody>
                          {inf.merchants.map(m => (
                            <tr key={m.user_id} className="border-b border-slate-50 hover:bg-slate-50">
                              <td className="py-1.5"><span className="font-medium text-slate-900">{m.company_name || m.name}</span>{m.city && <span className="text-slate-400 ml-1">({m.city})</span>}</td>
                              <td className="py-1.5"><code className="bg-slate-100 px-1.5 py-0.5 rounded text-xs font-mono">{m.key_used}</code></td>
                              <td className="py-1.5 text-center"><span className="capitalize">{m.plan}</span>{m.previous_plan && m.previous_plan !== m.plan && <span className="text-slate-400 ml-1">(de {m.previous_plan})</span>}</td>
                              <td className="py-1.5 text-center">{m.plan_activated_at ? new Date(m.plan_activated_at).toLocaleDateString('pt-BR') : '-'}</td>
                              <td className="py-1.5 text-center">{m.next_billing_date ? new Date(m.next_billing_date).toLocaleDateString('pt-BR') : '-'}</td>
                              <td className="py-1.5 text-center"><Badge className={`text-xs ${m.is_active ? 'bg-green-100 text-green-700 border-green-200' : 'bg-red-100 text-red-600 border-red-200'}`}>{m.is_active ? 'Ativo' : 'Cancelado'}</Badge></td>
                              <td className="py-1.5 text-right font-semibold">R$ {m.monthly_value}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : <p className="text-xs text-slate-400">Nenhum lojista vinculado</p>}
                </div>

                <div className="border-t border-slate-100 pt-4">
                  <h4 className="text-sm font-bold text-slate-700 mb-2">Extrato de Comissoes ({inf.commissions?.length || 0})</h4>
                  {inf.commissions?.length > 0 ? (
                    <div className="overflow-x-auto">
                      <table className="w-full text-xs">
                        <thead><tr className="border-b border-slate-200">
                          <th className="text-left py-1.5 text-slate-500">Data</th>
                          <th className="text-left py-1.5 text-slate-500">Lojista</th>
                          <th className="text-center py-1.5 text-slate-500">Plano</th>
                          <th className="text-center py-1.5 text-slate-500">Chave</th>
                          <th className="text-right py-1.5 text-slate-500">Mensalidade</th>
                          <th className="text-right py-1.5 text-slate-500">Comissao (10%)</th>
                          <th className="text-center py-1.5 text-slate-500">Status</th>
                        </tr></thead>
                        <tbody>
                          {inf.commissions.map(c => (
                            <tr key={c.commission_id} className="border-b border-slate-50 hover:bg-slate-50">
                              <td className="py-1.5">{new Date(c.created_at).toLocaleDateString('pt-BR')}</td>
                              <td className="py-1.5 font-medium">{c.company_name || c.merchant_name || c.merchant_id}</td>
                              <td className="py-1.5 text-center capitalize">{c.plan}{c.previous_plan && c.previous_plan !== c.plan && <span className="text-slate-400 ml-1">(upgrade de {c.previous_plan})</span>}</td>
                              <td className="py-1.5 text-center"><code className="bg-slate-100 px-1 py-0.5 rounded font-mono">{c.key_used}</code></td>
                              <td className="py-1.5 text-right">R$ {c.monthly_amount}{c.upgrade_diff > 0 && <span className="block text-slate-400">diff: R$ {c.upgrade_diff}</span>}</td>
                              <td className="py-1.5 text-right font-bold text-amber-700">R$ {c.commission_amount?.toFixed(2)}</td>
                              <td className="py-1.5 text-center"><Badge className={`text-xs ${c.status === 'paid' ? 'bg-green-100 text-green-700 border-green-200' : 'bg-amber-100 text-amber-700 border-amber-200'}`}>{c.status === 'paid' ? 'Pago' : 'Pendente'}</Badge></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : <p className="text-xs text-slate-400">Nenhuma comissao registrada</p>}
                </div>
              </div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
